// Page-level metadata used by SEO component
const base = 'https://www.ritehvacservices.com';
const commonKeywords = [
  'Rite HVAC Services',
  'HVAC repair Bloomington IN',
  'AC repair Bloomington Indiana',
  'Heating and cooling Bloomington IN',
  'Furnace installation Bloomington',
  'Emergency HVAC Bloomington IN',
  'AC maintenance Bloomington',
  'Duct cleaning Bloomington Indiana',
  'Indoor air quality Bloomington',
  'Commercial HVAC Bloomington IN',
  'Ellettsville','Bedford','Martinsville','Spencer'
];

const meta = {
  home: {
    title: 'Rite HVAC Services | HVAC Repair & Installation in Bloomington IN',
    description: '24/7 heating and cooling in Bloomington Indiana. EPA & NATE certified technicians for AC, furnace, boilers, heat pumps, IAQ, and duct cleaning.',
    canonical: base + '/'
  },
  about: {
    title: 'About Rite HVAC Services | Trusted Technicians in Bloomington IN',
    description: 'Rite HVAC Services is a local, certified team providing energy-smart heating and cooling. Learn our mission, values, certifications, and team.',
    canonical: base + '/about'
  },
  services: {
    title: 'HVAC Services in Bloomington IN | AC, Furnace, Heat Pumps, IAQ',
    description: 'Full-service HVAC: installation, repair, replacement, maintenance, duct cleaning, thermostats, zoning, and commercial plans.',
    canonical: base + '/services'
  },
  book: {
    title: 'Book an Appointment | Rite HVAC Services',
    description: 'Schedule HVAC service in minutes. Choose a date, describe the issue, and our Bloomington team will confirm promptly.',
    canonical: base + '/book'
  },
  contact: {
    title: 'Contact Rite HVAC Services | 24/7 Emergency HVAC Bloomington IN',
    description: 'Call +1 (812) 555-0168 or message us online. Office at 123 HVAC Drive, Bloomington, IN 47401.',
    canonical: base + '/contact'
  },
  faq: {
    title: 'HVAC FAQs | Bloomington IN Heating & Cooling Questions Answered',
    description: 'General, maintenance, repairs, costs, and installation FAQs for homeowners and facility managers in Bloomington IN.',
    canonical: base + '/faq'
  },
  blog: {
    title: 'HVAC Tips & Insights | Rite HVAC Blog',
    description: 'Local, seasonal advice for Bloomington IN homes and businesses: maintenance, energy efficiency, IAQ, and more.',
    canonical: base + '/blog'
  },
  caseStudies: {
    title: 'Case Studies & Recent Projects | Rite HVAC Services',
    description: 'Explore projects across Bloomington, Ellettsville, Bedford, Martinsville, and Spencer. Before/after results and ROI.',
    canonical: base + '/case-studies'
  },
  privacy: {
    title: 'Privacy Policy | Rite HVAC Services',
    description: 'How we collect, use, and protect your data when you request service or browse our site.',
    canonical: base + '/privacy'
  },
  terms: {
    title: 'Terms of Service | Rite HVAC Services',
    description: 'Website terms, service disclaimers, and user responsibilities for Rite HVAC Services.',
    canonical: base + '/terms'
  }
};

export default meta;
export { commonKeywords, base };
